<!--Coming soon starts-->
<section id="LoadingApp">
  
  <div [class.loading-message]="isLoading" style="display:none">
    <i class="ft-loader spinner loading-message-spinner"></i><i class="loadingdots loading-message-spinner"> {{ LoadingStatus | translate }} <span>.</span><span>.</span><span>.</span></i>
</div>

</section>
<!--Coming soon ends-->